export const environment = {
  production: false,
  apiUrl: 'https://rptmngapiv2dev.clavisco.com/',
};
